export default "__VITE_ASSET__B656XWaJ__"